import React from 'react'
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import {  Button } from '@material-ui/core'

const ShareButton = ({ searchEmployees, setSearchEmployees }) => (
  <Button
    className="mass-processing-share--button"
    onClick={() => setSearchEmployees(!searchEmployees)}
    style={{    
      height: '14px',
      padding: '0',
      textTransform: 'capitalize',
      margin: '0 10px'
    }}
  >
    <ShareIcon style={{color: '#33343a',width: '15px', height: '17px'}} /> 
    <span
      style={{
        font: 'normal Roboto',
        letterSpacing: '0.1px',
        color: '#393939'
      }}
    ></span>
      Share
    { searchEmployees 
      ? < ExpandLessIcon/> 
      : < ExpandMoreIcon/> 
    }
  </Button>
)

export default ShareButton